import { render, staticRenderFns } from "./DesktopTopNav.vue?vue&type=template&id=5d1268f7"
import script from "./DesktopTopNav.vue?vue&type=script&lang=js"
export * from "./DesktopTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports